(function(angular){
	'use strict';

	var scriptElement = document.getElementById('js-base-config-init');
	var basePath = window.location.pathname.indexOf('/fundrise') === 0 ? '/fundrise' : '';
	var cloudfrontDomain, riseCoReitId, mapboxToken, baseApiUrl, oauthToken, ajaxUploadUrl, selectedEntityId;

	if(scriptElement) {
		cloudfrontDomain = scriptElement.getAttribute('data-cloudfront-domain');
		riseCoReitId = parseInt(scriptElement.getAttribute('data-rise-co-reit-id'));
		mapboxToken = scriptElement.getAttribute('data-mapbox-token');
		baseApiUrl = scriptElement.getAttribute('data-base-api-url');
		oauthToken = scriptElement.getAttribute('data-oauth-access-token');
		ajaxUploadUrl = scriptElement.getAttribute('data-ajax-upload-url');
		selectedEntityId = scriptElement.hasAttribute('data-investment-entity-id') ? scriptElement.getAttribute('data-investment-entity-id') : undefined;
	} else {
		cloudfrontDomain = '';
		riseCoReitId = 0;
		baseApiUrl = '';
		oauthToken = '';
		ajaxUploadUrl = '';
	}
	
	angular
		.module('BaseConfig', [])
		.constant('APP_BASE_PATH', basePath)
		.constant('BREAKPOINTS', {
			'MD_START': 768,
			'LG_START': 1200
		})
		.constant('MAPBOX_TOKEN', mapboxToken)
		.constant('RISE_CO_REIT_ID', (riseCoReitId))
		.constant('API_BASE_PATH', baseApiUrl)
		.constant('STATIC_BASE_PATH', cloudfrontDomain)
		.constant('OAUTH_TOKEN', oauthToken)
		.constant('AJAX_UPLOAD_URL', ajaxUploadUrl)
		.constant('INVESTMENT_ENTITY_ID', selectedEntityId)
		.constant('TRADITIONAL_INVESTMENT_COMPS', {
			'PUBLIC_EQUITY_HYPOTHETICAL_QUARTERLY_RETURN': 0.01989817625,
			'VBMFX_ANNUALIZED_YIELD': 0.0257,
			'VNQ_ANNUALIZED_YIELD': 0.0315
		})
		.config([
			'$locationProvider',
			'$sceDelegateProvider',
			'STATIC_BASE_PATH',
			baseConfigFunction
		]);
	
	function baseConfigFunction($locationProvider, $sceDelegateProvider, STATIC_BASE_PATH) {
		$locationProvider.html5Mode({
			enabled : true,
			requireBase : false,
			rewriteLinks: false
		});

		$sceDelegateProvider.resourceUrlWhitelist([
			'self',
			STATIC_BASE_PATH + '/**',
			'https://player.vimeo.com/**',
			'https://www.youtube.com/embed/**',
			'https://sz0wppll35.execute-api.us-east-1.amazonaws.com/**',
			baseApiUrl + '/**'
		]);
	}
})(window.angular);